<template>
	<div
		v-if="technologies.cms"
		class="flex cursor-pointer justify-center items-center h-full"
	>
		<img
			v-if="technologies.cms.name"
			:src="getImagePath(technologies.cms.code.toLowerCase())"
			alt="graphic-404"
			style="width: 25px; height: 25px"
		/>
	</div>
	<div v-else>-</div>
</template>
  
  <script>
import fileFinderMixin from "../../../../../mixins/fileFinderMixin";
// import PropsectTechnologyPopup from "../ProspectTechnologyPopup.vue";
export default {
	// props: {
	// 	onePs: Object, // Pass the data object that contains the `id` and `url`
	// },
	name: "CmsRenderer",
	data() {
		return {
			onePs: {},
			technologies: {},
		};
	},
	mixins: [fileFinderMixin],
	created() {
		this.onePs = this.params.data;
		this.technologies = JSON.parse(this.onePs.technologies[0].services);
	},
	components: {},
	methods: {
		// handleClick() {
		// 	this.displayTechnologies(this.onePs.id, this.onePs.url);
		// },
		// /**
		//  * Popup Issues Details
		//  * @param {Number} pid - prospect Id
		//  * @param {String} url - prospect url
		//  */
		// displayTechnologies(pid, url) {
		// 	let ComponentClass = Vue.extend(PropsectTechnologyPopup);
		// 	let technologiesPopup = new ComponentClass({
		// 		propsData: {
		// 			popupActive: true,
		// 			prsopect_id: pid,
		// 			prospect_url: url,
		// 		},
		// 	});
		// 	technologiesPopup.$mount();
		// 	this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		// },
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>